import React from 'react'
import NotFound404 from '../components/404'
import ContactusBanner from '../components/ContactusBanner'
import ContactForm from '../components/ContactForm'
import ContactCards from '../components/ContactCard'
function ContactPage  ()  {
  return (
    <div>
        <ContactusBanner />
       
        <ContactCards />
      
        <ContactForm />
      {/* <NotFound404 /> */}
    </div>
  )
}

export default ContactPage
